var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(this.show)?_c('div',{staticClass:"loading"},[_c('img',{staticClass:"loading-img",attrs:{"src":require("@/assets/images/loading.svg")}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }